import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';
import type { ListingLayoutState } from '../slice';

export const listingLayoutSelector = rootStateBranchSelector('listingLayout');

export function useListingLayoutSelector(): ListingLayoutState {
  return useReduxSelector(listingLayoutSelector);
}
